import type { NextPage } from "next"
import ModuleList from "src/components/module-list/ModuleList"
import { BaseModule, PageThemeType, SanityCallToAction } from "src/sanity/types"
import cn from "classnames"
import s from "./inAppPage.module.scss"
import CallToAction from "src/components/call-to-action/CallToAction"

export interface InAppPageDocument {
    id: string
    title: string
    slug: {
        current: string
    }
    pageThemeType?: PageThemeType
    floatingCta: SanityCallToAction
    modules: BaseModule[]
    updatedAt?: string
}

const Template: NextPage<{ pageData: InAppPageDocument }> = ({ pageData }) => {

    return (
        <>
            <div className={cn(s["container"])}>
                <ModuleList modules={pageData?.modules} pageThemeType={pageData?.pageThemeType} updatedAt={pageData.updatedAt} />
                <div className={cn(s["floating-cta"])} data-module-name="in-app-floating-cta" onMouseDown={() => {const queue = window?.["_paq"]; queue?.push(["trackGoal", "75fdfbce-16f1-4076-8f2f-f78a44896d46"])}}>
                    <CallToAction
                        {...pageData.floatingCta}
                    />
                </div>
            </div>
        </>
    )
}

export default Template
